<template>
  <div class="flex-column-start-center sidebar-wrapper"
    :class="{ 'collapsed': isSidebarCollapsed }"
    :data-page="pathSegment" v-if="!loading"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <router-link v-if="pathSegment != 'case' && !isSidebarCollapsed" to="/worklist" exact class="logo-wrapper">
      <img src="@/assets/images/visque_dps_logo.png" id="main-logo" alt="visque-dps-logo">
    </router-link>
    
    <div v-if="pathSegment != 'case' && !isSidebarCollapsed" class="sidebar-list-wrapper">
      <div :class="[ 'flex-row-between-center', 'sidebar-item', { selected: 0 == idWorklist }]" @click="moveToDefaultWorklist(0)" >
        <div class="flex-row-start-center">
          <span class="worklist-status-icon-box"><img :src="getWorklistStatusIcon(0)" :alt="`status-${0}`" class="worklist-status-icon" /></span>
          <span>{{ translateDefaultWorklst(0) }}</span>
        </div>
        <div>{{ defaultStatusList.reduce((sum, item) => sum + item.count, 0) }}</div>
      </div>
      <cytomine-searcher />

      <hr class="hr-style">
      <div
        v-for="status in defaultStatusList"
        :key="status.status"
        @click="moveToDefaultWorklist(status.status)"
        :class="[ 'flex-row-between-center', 'sidebar-item', { selected: status.status == idWorklist }]"
      >
      <!-- default worklist / id 확인 -->
        <div class="flex-row-start-center worklist-name" :title="translateDefaultWorklst(status.status)">
          <span class="worklist-status-icon-box"><img :src="getWorklistStatusIcon(status.status)" :alt="`status-${status.status}`" class="worklist-status-icon" /></span>
          <span>{{ translateDefaultWorklst(status.status) }}</span>
        </div>
        <div>{{ status.count }}</div>
      </div>
      <hr class="hr-style">
      <div
        v-for="status in statusList"
        :key="status.name"
        :class="[ 'flex-row-between-center', 'sidebar-item', { selected: status.id == idWorklist }]"
      >
      <!-- private worklist / id 확인 -->
        <div @click="moveToWorklist(status.id, status.name)" style="cursor: pointer;" class="worklist-name" :title="status.name">
          {{ status.name }}
        </div>
        <div class="worklist-actions">
          <i class="fas fa-pen action-icon" @click.stop="openRenameModal(status)" title="Rename"></i>
          <i class="fas fa-trash-alt action-icon" @click.stop="openDeleteModal(status)" title="Delete"></i>
        </div>
        <div @click="moveToWorklist(status.id, status.name)" style="flex: 1; cursor: pointer; text-align: right;">
          {{ status.projectCount }}
        </div>
      </div>

      <add-worklist-modal 
        :active.sync="creationModal" 
        :mode="modalMode"
        :worklist="selectedWorklistForModal"
        @renamed="handleWorklistRenamed"
        @deleted="handleWorklistDeleted"
      /> 
    </div>

    <div v-if="pathSegment == 'case'" class="flex-column-start-center sidebar-imagelist-wrapper">
      <div v-show="!isSidebarCollapsed" class="sidebar-content-container">
        <div class="case-name-label">Case: {{ caseName }}</div>
        <div class="flex-row-between-center toggle-wrapper">
          <div class="toggle-item" v-for="toggleItem in toggleList" :key="toggleItem" :class="{ 'selected-toggle-item': toggleItem === toggleSelected }">
            <label class="toggle-label" @click="toggleChange(toggleItem)" >{{ toggleItem }}</label>
          </div>
        </div>
        <!-- <div class="list-filter-wrapper">이미지들 중 필터링 또는 검색 기능</div> -->
        <div class="list-filter-wrapper"></div>

        <div class="sidebar-image-list-content">
          <image-selector v-show="toggleSelected == 'Images'" />
          <attached-files v-show="toggleSelected == 'Attached File'" :object="project" :canEdit="canManageProject" :sidebar="true" />
        </div>
      </div>
    </div>

    <!-- Hamburger Menu Button -->
    <div v-if="pathSegment != 'case' && !isSidebarCollapsed"
        class="hamburger-menu-button"
        @click.stop="toggleMenu"
      >
      <i class="fas fa-ellipsis-v"></i>
    </div>

    <!-- Menu Dropdown -->
    <div v-if="showMenu && pathSegment != 'case' && !isSidebarCollapsed" 
      class="menu-dropdown"
      v-click-outside="closeMenu"
    >
      <div class="menu-item" v-if="currentUser && (currentUser.adminByNow || !currentUser.guestByNow)" @click="handleCreateWorklist">
        <i class="fas fa-plus"></i>
        <span>{{$t('create-worklist')}}</span>
      </div>
      <div class="menu-item" v-if="currentUser && (currentUser.adminByNow || !currentUser.guestByNow)" @click="handleStorage">
        <i class="fas fa-database"></i>
        <span>{{$t('storage')}}</span>
      </div>
      <div class="menu-item" v-if="currentUser && currentUser.adminByNow" @click="handleAdmin">
        <i class="fas fa-user-shield"></i>
        <span>{{$t('admin-menu')}}</span>
      </div>
      <div class="menu-item" @click="handleShortcuts">
        <i class="fas fa-keyboard"></i>
        <span>Shortcuts</span>
      </div>
    </div>

    <div  v-if="pathSegment == 'case'" class="back-button-wrapper">
      <div class="sidebar-back-button" @click="closeViewer" >
        <i class="fas fa-arrow-left"></i>
      </div>
    </div>

    <div v-if="pathSegment == 'case' && !isSidebarCollapsed"
      class="sidebar-pin-button"
      @click="togglePinStatus"
    >
      <i class="fas fa-thumbtack" :class="[  isSidebarPinned ? 'sidebarPinnedButton' : 'sidebarNotPinnedButton' ]" ></i>
    </div>

    <div 
      v-if="pathSegment != 'case' && !isSidebarCollapsed" 
      class="sidebar-bottom-profile" 
      @click="handleProfile"
    >
      <b-button icon-left="user">
        <span>{{ currentUser.firstname }} {{ currentUser.lastname }} ({{ currentUser.username }})</span>
      </b-button>
    </div>
  </div>
</template>


<script>
import DefaultWorklist from '@/enums/DefaultWorklist.js';
import {get} from '@/utils/store-helpers';
import {ProjectCollection, WorklistCollection} from 'cytomine-client';
import AddWorklistModal from '../worklist/AddWorklistModal';
import ImageSelector from '../viewer/ImageSelector';
import AttachedFiles from '@/components/attached-file/AttachedFiles';
import CytomineSearcher from '@/components/search/CytomineSearcher';
import HotkeysModal from '@/components/navbar/HotkeysModal';

export default {
  name: 'sidebar-component',
  components: {
    AddWorklistModal,
    ImageSelector,
    AttachedFiles,
    CytomineSearcher,
  },
  data() {
    return {
      loading: true,
      defaultStatusList: [],
      statusList: [],
      
      creationModal: false,
      modalMode: 'add',
      selectedWorklistForModal: null,
      selectedWorklist: {},

      pathSegment: null,
      idCase: null,
      caseName: null,

      toggleList: ['Images', 'Attached File'],
      toggleSelected: 'Images',

      worklistList: [],
      managers: [],

      editable: true,
      image: null,
      
      isSidebarCollapsed: true,
      isSidebarPinned: false,
      showMenu: false,
      hotkeysModal: null,

      revision: 0,
    };
  },
  watch: {
    '$route': {
      immediate: true, // 컴포넌트 생성 시 즉시 실행
      handler(to) {
        this.handleRouteChange(to);
      }
    },
    currentWorklist: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.selectedWorklist = newVal;
        }
      }
    },
  },
  computed: {
    project: get('currentProject/project'),
    currentUser: get('currentUser/user'),
    canManageProject() {
      return this.editable && (this.currentUser.adminByNow || this.managersIds.includes(this.currentUser.id));
    },
    currentWorklist() {
      return this.$store.getters['worklist/getCurrentWorklist'];
    },
    sortPropWorklist() {
      return this.$route.params.sortPropWorklist;
    },
    idWorklist() {
      return this.$route.params.idWorklist;
    },
    managersIds() {
      return this.managers.map(manager => manager.id);
    },
  },
  methods: {
    togglePinStatus() {
      this.isSidebarPinned = !this.isSidebarPinned;

      const theme = JSON.parse(localStorage.getItem('theme') || '{}');
      theme.sidebarExpanded = this.isSidebarPinned;
      localStorage.setItem('theme', JSON.stringify(theme));
    },
    onMouseEnter() {
      if (this.isSidebarPinned) return;
      this.isSidebarCollapsed = false;
    },
    onMouseLeave() {
      if (this.isSidebarPinned) return;
      this.isSidebarCollapsed = true;
    },
    closeViewer() {
      const savedHierarchy = JSON.parse(localStorage.getItem('worklistHierarchy') || '{}');
      this.$router.push(`/worklist/${savedHierarchy.sortPropWorklist}-${savedHierarchy.idWorklist}/case/${this.$route.params.idCase}?tab=images`);
    },
    getWorklistStatusIcon(statusId) {
      // require를 사용하여 동적으로 이미지를 로드합니다
      // 웹팩이 빌드 시 이 경로들을 올바르게 처리할 수 있도록 합니다
      try {
        return require(`@/assets/images/worklist-status-${statusId}.svg`);
      }
      catch (e) {
        // 이미지가 없을 경우 기본 이미지를 반환하거나 빈 문자열 반환
        console.warn(`Icon not found for status ${statusId}`);
        return require('@/assets/images/worklist-status-default.svg'); // 기본 아이콘 경로를 반환
      }
    },
    updateStatusListFromWorklists(worklists) {
      // worklists 배열이 { id, name, ... } 형태라고 가정
      // this.statusList = worklists.map(item => ({ name: item.name, projectCount: item.projectCount }));
      this.statusList = worklists;
    },
    async getWorklistCollection() {
      let data = await WorklistCollection.fetchAll({filterKey: 'user', filterValue: this.currentUser.id});
      return data;
    },
    moveToDefaultWorklist(id) {
      if (this.$route.path === `/worklist/status-${id}`) {
        return;
      }

      this.selectDefaultWorklist({ id });

      this.$router.push({ path: `/worklist/status-${id}` }).catch((err) => {
        throw err;
      });
    },
    moveToWorklist(id, name) {
      this.selectWorklist({id, name});

      this.$router.push({ path: `/worklist/id-${id}` }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    selectDefaultWorklist(status) {
      this.$store.commit('worklist/setDefaultWorklist', status);
    },
    selectWorklist(status) {
      this.$store.commit('worklist/setWorklist', status);
    },
    translateDefaultWorklst(state) {
      return DefaultWorklist[state];
    },
    async getProjectCollection() {
      let data = await ProjectCollection.fetchInfos({ withDetails: true });

      let divide = Object.keys(DefaultWorklist)
        .filter(key => !isNaN(key) && Number(key) !== 0) 
        .sort((a, b) => a - b)
        .map(status => ({
          status: Number(status),
          count: 0
        }));

      data.collection.forEach(item => {
        const status = item.status;

        if (DefaultWorklist[status] !== undefined) {
          const target = divide.find(d => d.status === status);
          if (target) target.count++;
        }
      });

      return divide;
    },
    // fetchWorklists() {
    //   // this.sortPropWorklist 가 "status" 면, status에 id 값을 넣어 보내고 / "id" 면, id에 id 값을 넣어 보내기
    //   if (this.sortPropWorklist === 'status') {
    //     this.selectDefaultWorklist({ id: this.idWorklist });
    //   }
    //   else if (this.sortPropWorklist === 'id') {
    //     // TODO: 이름도 넣어줘야 함 , name: 
    //     this.selectWorklist({ id: this.idWorklist, name: this.selectedWorklist.name });
    //   }
    // },
    async handleRouteChange(route) {
      // /#/ 이후의 hash 경로를 가져옴
      const path = route.hash ? route.hash.slice(1) : route.path; 
      const segments = path.split('/').filter(Boolean);
      if (segments.length > 0) {
        this.pathSegment = segments[0];
        this.idCase = segments[1] || null;

        // 필요 시 비동기 처리 호출
        if (this.pathSegment === 'case' && this.idCase) {
          let defaultInfo = await ProjectCollection.fetchDefaultInfo(null, this.$route.params.idCase);

          // TODO: 조회 결과 없을 시, 에러 팝업 발생
          this.caseName = defaultInfo.caseName;
        }
      }
      
      // 사이드바의 너비 설정을 변경하는 부분
      if (this.pathSegment === 'case') { // 뷰잉 화면
        const theme = JSON.parse(localStorage.getItem('theme') || '{}');
        const sidebarExpanded = theme.sidebarExpanded === true;

        if (sidebarExpanded) { // 확장&고정 상태
          this.isSidebarCollapsed = false;
          this.isSidebarPinned = true;
        }
        else {
          this.isSidebarCollapsed = true;
          this.isSidebarPinned = false;
        }
      }
      else { // 뷰잉 외 화면
        this.isSidebarCollapsed = false;
        this.isSidebarPinned = true;
      }
    },
    toggleChange(selectedItem) {
      this.toggleSelected = selectedItem;
    },
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    async refreshWorklistData() {
      // worklist 목록을 다시 불러오기
      this.worklistList = await this.getWorklistCollection();
      this.updateStatusListFromWorklists(this.worklistList._data);
      this.defaultStatusList = await this.getProjectCollection();
    },
    openAddModal() {
      this.modalMode = 'add';
      this.selectedWorklistForModal = null;
      this.creationModal = true;
    },

    openRenameModal(worklist) {
      this.modalMode = 'rename';
      this.selectedWorklistForModal = worklist;
      this.creationModal = true;
    },

    openDeleteModal(worklist) {
      this.modalMode = 'delete';
      this.selectedWorklistForModal = worklist;
      this.creationModal = true;
    },

    async handleWorklistRenamed(updatedWorklist) {
      // Refresh the worklist data
      await this.refreshWorklistData();
      
      // If we're currently viewing the renamed worklist, update the store
      if(this.currentWorklist && this.currentWorklist.id === updatedWorklist.id) {
        this.$store.commit('worklist/setWorklist', {
          id: updatedWorklist.id, 
          name: updatedWorklist.name
        });
      }
    },

    async handleWorklistDeleted() {
      // Refresh the worklist data
      await this.refreshWorklistData();
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    
    closeMenu() {
      this.showMenu = false;
    },

    handleCreateWorklist() {
      this.openAddModal();
      this.closeMenu();
    },

    handleStorage() {
      this.$router.push('/storage').catch(() => {});
      this.closeMenu();
    },

    handleAdmin() {
      this.$router.push('/admin').catch(() => {});
      this.closeMenu();
    },

    handleProfile() {
      this.$router.push('/account').catch(() => {});
      this.closeMenu();
    },

    handleShortcuts() {
      if (!this.hotkeysModal) {
        this.hotkeysModal = this.$buefy.modal.open({
          parent: this,
          component: HotkeysModal,
          hasModalCard: true,
          onCancel: () => this.hotkeysModal = null,
        });
      }
      this.closeMenu();
    },
    async fetchManagers() {
      this.managers = (await this.project.fetchAdministrators()).array;
    },
  },
  mounted() {
    // Event bus를 통해 워크리스트 갱신 이벤트 리스닝
    this.$eventBus.$on('refreshWorklist', this.refreshWorklistData);
  },
  beforeDestroy() {
    // Event bus 리스너 제거
    this.$eventBus.$off('refreshWorklist', this.refreshWorklistData);
  },
  async created() {
    this.worklistList = await this.getWorklistCollection();
    this.updateStatusListFromWorklists(this.worklistList._data);
    
    
    const sortProp = this.$route.params.sortPropWorklist;
    const id = this.$route.params.idWorklist;
    if (sortProp == 'id') {
      let selectedWorklist = this.worklistList._data.find(el => el.id == Number(this.$route.params.idWorklist));
      this.selectWorklist({id, name: selectedWorklist.name});
    }
    else {
      this.selectDefaultWorklist({id});
    }

    this.defaultStatusList = await this.getProjectCollection();
    if (this.pathSegment == 'case')
      await this.fetchManagers();

    this.loading = false;
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          // 클릭한 요소가 메뉴나 버튼이 아닌 경우에만 닫기
          const menuButton = vnode.context.$el.querySelector('.hamburger-menu-button');
          if (!(el === event.target || el.contains(event.target) || 
                menuButton === event.target || menuButton.contains(event.target))) {
            binding.value();
          }
        };
        // 약간의 지연을 주어 버튼 클릭 이벤트가 먼저 처리되도록 함
        setTimeout(() => {
          document.body.addEventListener('click', el.clickOutsideEvent);
        }, 0);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  }
};

</script>

<style scoped lang="scss">

.worklist-name {
  max-width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-wrapper {
  position: relative;
  
  width: 20%;
  min-width: 200px;
  height: calc(100vh - 10px);
  margin: 5px 0;
  background-color: #F4F4F4;

  border-radius: 8px;
  transition: width 0.3s ease, min-width 0.3s ease;
  
  // case 페이지에서만 floating 스타일 적용
  &[data-page="case"] {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, width 0.3s ease, min-width 0.3s ease, opacity 0.3s ease;
  }
}

.sidebar-wrapper.collapsed {
  width: 56px;
  min-width: 56px;
}

.logo-wrapper {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

#main-logo {
  width: 65%;
  margin: 9% auto;
}

.sidebar-list-wrapper {
  overflow-y: auto;
  width: 80%;
  margin-top: 0.8rem;

  // background-color: #red;
}

.sidebar-imagelist-wrapper {
  position: relative;
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-content-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.sidebar-image-list-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  width: 100%;
  margin-bottom: 56px;
}

.sidebar-item {
  border-radius: 5px;
  padding: 0.3rem 1rem;
  
  cursor: pointer;
}

.worklist-actions {
  display: flex;
  gap: 8px;
  margin-left: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.worklist-status-icon-box {
  display: inline-block;
  width: 1em;
  margin-right: 8px;
  text-align: center;
}

.worklist-status-icon {
  max-width: 1em;
  max-height: 1.1em;
  vertical-align: middle;
  position: relative;
  top: -1px;
}

.sidebar-item:hover .worklist-actions {
  opacity: 1;
}

.action-icon {
  cursor: pointer;
  font-size: 0.85rem;
  color: #666;
  transition: color 0.2s ease;
}

.action-icon:hover {
  color: #009BDB;
}

.selected {
  background-color: #ffffff;
  box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.05);
  font-weight: bold;
}

.hr-style {
  background-color: #D3D3D3;
  width: 90%;
  height: 1px;
  margin: 5px auto;
}

.hamburger-menu-button {
  position: absolute;
  bottom: 16px;
  left: 16px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  
  i {
    font-size: 16px;
    color: #666;
  }
  
  &:hover {
    background-color: #ffffff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    
    i {
      color: #009BDB;
    }
  }
}

.menu-dropdown {
  position: absolute;
  bottom: 56px;
  left: 16px;
  
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  min-width: 180px;
  z-index: 1000;
  
  // 메뉴를 위쪽으로 펼치기
  transform-origin: bottom left;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  i {
    width: 16px;
    font-size: 14px;
    color: #666;
  }
  
  span {
    font-size: 14px;
    color: #333;
  }
  
  &:hover {
    background-color: #f0f0f0;
    
    i, span {
      color: #009BDB;
    }
  }
}

.setting-button {
  position: absolute;
  bottom: 16px;
  left: 16px;
  width: 20px;
  height: 20px;
  cursor: pointer;

  transition: opacity 0.2s ease;
}

.setting-button:hover {
  opacity: 0.7;
}

.sidebar-back-button {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  
  i {
    font-size: 14px;
    color: #666;
  }
}

.sidebar-back-button:hover {
  opacity: 0.7;
}


.sidebar-pin-button {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  display: flex;
  align-items: center;
  justify-content: center;
  
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  
  i {
    font-size: 14px;
    color: #333;
  }
}

.sidebar-pin-button:hover {
  opacity: 0.7;
}

// 케이스 화면 상태의 sidebar (이미지 리스트)
.case-name-label {
  font-size: 1.4rem;
  padding-top: 60px;
  padding-bottom: 18px;
  flex-shrink: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  width: 100%;
}

.toggle-wrapper {
  width: 70%;
  padding: 4px;
  border-radius: 8px;
  background-color: #e1e1e1;

  display: flex;
  gap: 5px;
  flex-shrink: 0;
  margin: 0 auto;
}

.toggle-item {
  cursor: pointer;
  border-radius: 7px;
  padding: 4px 0;
  flex-grow: 1;
  flex-shrink: 0;

  text-align: center;
}

.toggle-label {
  cursor: pointer;
}

.selected-toggle-item {
  background-color: #f4f4f4;
  color: #009BDB;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.list-filter-wrapper {
  // margin: 24px 0;
  margin: 12px 0;
  width: 100%;
  background-color: white;
  flex-shrink: 0;
}

.back-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.sidebarPinnedButton {
  color:#333 !important
}
.sidebarNotPinnedButton {
  color:#d5d5d5  !important
}

.sidebar-bottom-profile {
  position: absolute;
  bottom: 16px;
  right: 16px;
}

</style>
